
/**
 * Utility function to fetch timezone information from Google Time Zone API
 */
export const fetchTimeZoneInfo = async (
  latitude: number, 
  longitude: number,
  apiKey: string
): Promise<string | null> => {
  try {
    const timestamp = Math.floor(Date.now() / 1000); // Current time in seconds
    const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=${timestamp}&key=${apiKey}`;
    
    const response = await fetch(url);
    const data = await response.json();
    
    if (data.status === 'OK') {
      // Return the timezone name (e.g., "Pacific Daylight Time")
      return data.timeZoneName;
    } else {
      console.error('Time Zone API request failed:', data.status);
      return null;
    }
  } catch (error) {
    console.error('Error fetching timezone:', error);
    return null;
  }
};
